<div class="field">
    <label [for]="formControlName" class="font-medium text-900">
        {{label}}
     </label>
    <textarea
        [id]="formControlName"
        pInputText
        [(ngModel)]="value"
        (ngModelChange)="onChange($event)"
        (blur)="onTouched()"
        [disabled]="isDisabled"
        class="p-inputtextarea p-inputtext p-component p-element p-inputtextarea-resizable"
        rows="5"
        style="height: 114px; overflow: hidden;"
        [class.ng-invalid]="control.invalid && (control.dirty || control.touched)"
        [class.ng-dirty]="control.invalid && (control.dirty || control.touched)"
    ></textarea>
    <div *ngIf="control?.invalid && (control.dirty || control.touched)" class="text-red-50">
        <small class="text-red-400">{{errorMessage(control)}}</small>
    </div>
</div>
<!--[class.ng-invalid]="control?.invalid && (control.dirty || control.touched)"-->